import { api } from '@web/core/http/api';
import type { LeadDetails } from './contract';

/**
 * The leads of before spec 071's phase 4, read only (ADR 0019): an old link finds what the lead
 * became. No lead is listed, made, pulled or discarded any more.
 */
export const leadsApi = {
  get: (id: string) => api.get<LeadDetails>(`/leads/${id}`),
};
